import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import BcTable from '@/components/Table.vue';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
// @ts-ignore
import BcDialog from '@/components/Dialog.vue';
let SalesOrder = class SalesOrder extends Vue {
    constructor() {
        super(...arguments);
        this.snackbar = new CBcSnackbar();
        this.searchForm = {
            keyword: '',
            displayOption: 0,
            dates: [],
            timer: null,
            orderStatus: [],
        };
        this.orderTableOption = {
            loading: false,
            headers: [
                {
                    text: '客户名称',
                    align: 'left',
                    sortable: false,
                    value: 'customerName',
                },
                {
                    text: '申请单编号',
                    align: 'center',
                    sortable: false,
                    value: 'orderNumber',
                },
                {
                    text: '订单类型',
                    align: 'center',
                    sortable: false,
                    value: 'orderType',
                    width: '80',
                },
                {
                    text: '退库日期',
                    align: 'center',
                    sortable: false,
                    value: 'returnDate',
                },
                {
                    text: '申请人员',
                    align: 'left',
                    sortable: false,
                    value: 'applicant',
                },
                {
                    text: '申请日期',
                    align: 'center',
                    sortable: false,
                    value: 'applicationDate',
                    width: '115',
                },
                {
                    text: '审核',
                    align: 'center',
                    sortable: false,
                    value: 'auditor',
                    width: '140',
                },
                {
                    text: '审批',
                    align: 'center',
                    sortable: false,
                    value: 'approver',
                    width: '140',
                },
                {
                    text: '订单状态',
                    align: 'center',
                    sortable: false,
                    value: 'orderStatus',
                    width: '140',
                },
                {
                    text: '操作',
                    align: 'center',
                    sortable: false,
                    value: 'action',
                    width: '165',
                },
            ],
            desserts: [],
            pagination: {
                pageCount: 1,
                pageNow: 1,
                pageArr: [5, 10, 20, 50, '所有'],
                everyPageCount: 10,
                sumDetail: 0,
            },
        };
        this.operDateArray = ['returnDate', 'applicationDate', 'auditDate', 'approvalDate'];
        this.dialogOrder = {
            visible: false,
            loading: false,
            title: '',
            operType: 'add',
            form: false,
            formData: {},
            products: [],
        };
        this.dialogProduct = {
            visible: false,
            loading: false,
            title: '',
            operType: 'add',
            form: false,
            formData: {},
            products: [],
        };
        // 订单状态信息
        this.dialogStatus = {
            visible: false,
            loading: false,
            title: '',
            operType: 'confirm',
            form: false,
            formData: {},
            formOption: {},
        };
        // 初版订单状态根据确认人信息进入对应的状态，原则上是需要制单人手动提交一次才能进入下一阶段，并且下一阶段不允许修改，初版先不做限制
        this.orderStatusArray = [
            {
                value: 0,
                label: '待提交',
                color: '#607d8b',
            },
            {
                value: 1,
                label: '待审核',
                text: '审核',
                fieldName: 'auditor',
                fieldDate: 'auditDate',
                color: '#5cbbf6',
            },
            {
                value: 2,
                label: '待审批',
                text: '审批',
                fieldName: 'approver',
                fieldDate: 'approvalDate',
                color: '#2196f3',
            },
            { value: 3, label: '待寄出', color: '#00897B' },
            { value: 4, label: '配送中', color: '#8BC34A' },
            { value: 5, label: '已收货待质检', color: '#4caf50' },
            { value: 6, label: '已完成', color: '#00BCD4' },
            { value: 7, label: '已作废', color: '#ff5252' },
        ];
        this.userInfoDic = {
            list: [],
            value: undefined,
            loading: true,
        };
        this.productList = []; // 产品信息
    }
    get dateRangeText() {
        let str = '';
        if (this.searchForm.dates.length > 0) {
            str = this.searchForm.dates.join(' ~ ');
        }
        return str;
    }
    /**
     * 获取表单禁用状态
     */
    get getFormDisabled() {
        const that = this;
        return that.dialogOrder.operType === 'send' || that.dialogOrder.operType === 'detail' || that.dialogOrder.operType === 'sign';
    }
    productFilter(item, queryText, itemText) {
        return (new RegExp(queryText.toUpperCase(), 'i').test(item['productName'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['model'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['shortName'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['orderNumber'] || ''));
    }
    /**
     * 产品发生变更时
     */
    productInfoChange(row) {
        const that = this;
        // 判断是否有重复的产品
        const index = that.dialogOrder.products.findIndex((o) => o.productInfoId == row.productInfo.id);
        if (index > -1) {
            that.snackbar.warn(`添加产品重复，请直接追加【${row.productInfo.productName}】数量.`);
            that.$nextTick(() => {
                that.setProductInfo({}, row);
                // 清空这一行
                that.$set(row, 'productInfo', null);
            });
            return false;
        }
        that.setProductInfo(row.productInfo, row);
    }
    /**
     * 设置产品值
     * @param productInfo
     * @param row
     */
    setProductInfo(productInfo, row) {
        const that = this;
        row.productInfoId = productInfo.id;
        row.productName = productInfo.productName;
        row.model = productInfo.model;
        row.quantityUnit = productInfo.unit;
        row.specifications = productInfo.specifications;
    }
    /**
     * 显示订单表单
     */
    async showOrderFormClick(operType, row) {
        const that = this;
        // 添加
        async function addFunc() {
            that.dialogOrder.title = '新增退库申请单';
            that.dialogOrder.formData.orderType = '试用';
            that.generateOrderNo();
            that.dialogOrder.formData.applicationDate = new Date().format('yyyy-MM-dd');
            that.dialogOrder.formData.applicant = (that.userInfo || {}).userName; // 获取当前操作人
            await that.getProductList();
        }
        // 修改
        async function editFunc() {
            that.dialogOrder.title = '修改退库申请单信息';
            await that.getProductList();
            that.dialogOrder.products = await that.getSalesProduct({
                salesReturnOrderId: row.id,
            });
            if (that.dialogOrder.products.length > 0) {
                that.dialogOrder.products.forEach((item) => {
                    item.productInfo = that.productList.find((o) => o.id == item.productInfoId);
                });
            }
        }
        // 删除
        async function deleteFunc() {
            that.dialogOrder.title = '删除生产申请单';
        }
        // 退库设备发货
        async function sendFunc() {
            await editFunc();
            that.dialogOrder.title = '发货确认';
        }
        // 完成生产
        async function signFunc() {
            await editFunc();
            that.dialogOrder.title = '收货确认';
        }
        // 入库（不能直接入库，需提交质检，存在问题的就质检不通过转生产）
        async function storeFunc() {
            that.dialogProduct.visible = true;
            that.dialogProduct.title = '提交质检申请确认';
            that.dialogProduct.formData.applicationDate = new Date().format('yyyy-MM-dd');
            that.dialogProduct.formData.applicant = (that.userInfo || {}).name;
            that.dialogProduct.formData.remark = `退库订单${row.orderNumber}生成品控质检单。`;
            that.dialogProduct.formData.salesOrderId = row.id; // 订单id
            that.dialogProduct.formData.salesOrderType = row.orderType; // 订单类型
            that.dialogProduct.formData.salesOrderNumber = row.orderNumber; // 订单编号
            that.dialogProduct.formData.dataSource = 1; // 1-退库单
            // 处理产品信息
            that.dialogProduct.products = [];
            await that.getProductList();
            row.products.forEach((p) => {
                const pro = that.productList.find((o) => o.id == p.productInfoId);
                if (!pro)
                    return;
                // 这里根据申请单数量生成产品总数，需要人工录入产品id，区分独立设备和包装产品
                if (pro.category == 1) {
                    // 包装产品时
                    var row = {};
                    that.setProduct(pro, row);
                    row.stockInOutQuantity = p.quantity; // 数量
                    row.quantityUnit = p.quantityUnit; // 数量单位
                    row.remark = p.remark;
                    that.dialogProduct.products.push(row);
                    return;
                }
                // 独立产品时
                for (let index = 0; index < p.quantity; index++) {
                    var row = {};
                    that.setProduct(pro, row);
                    row.stockInOutQuantity = 1; // 数量
                    row.quantityUnit = p.quantityUnit; // 数量单位
                    row.remark = p.remark;
                    that.dialogProduct.products.push(row);
                }
            });
        }
        async function detail() {
            await editFunc();
            that.dialogOrder.title = '查看订单详情';
        }
        that.dialogOrder.operType = operType;
        that.dialogOrder.formData = Object.assign({}, row || {});
        that.dialogOrder.products = []; // 清空产品信息
        if (operType === 'add') {
            await addFunc();
        }
        else if (operType === 'edit') {
            await editFunc();
        }
        else if (operType === 'send') {
            await sendFunc();
        }
        else if (operType === 'sign') {
            await signFunc();
        }
        else if (operType === 'detail') {
            await detail();
        }
        else if (operType === 'store') {
            await storeFunc();
            return;
        }
        else {
            await deleteFunc();
        }
        that.dialogOrder.visible = true;
    }
    /**
     * 保存库存信息
     */
    async saveProductInventory() {
        const that = this;
        if (!that.$refs['refFormStore'].validate()) {
            that.snackbar.warn('请填写必要字段后重新保存.');
            return;
        }
        that.dialogProduct.loading = true;
        const forms = that.getExamineFormInfo(that.dialogProduct.formData);
        await that.axios
            .post('/api/erp/order/quality', forms)
            .then(async (res) => {
            that.dialogProduct.loading = false;
            // 提示成功刷新页面
            that.dialogProduct.visible = false;
            // 修改订单状态
            const url = '/api/erp/order/sales/return/status/' + that.dialogProduct.formData.salesOrderId;
            await that.sendOrderSalesResponse({
                month: 'put',
                url: url,
                form: { orderStatus: 6 },
                msg: '提交质检成功，并且更新',
            });
            that.getDataList();
        })
            .catch((e) => {
            that.dialogProduct.loading = false;
            const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
            that.snackbar.error(`提交质检申请单错误${resMeg}`);
            console.log('提交质检申请单错误', e);
        });
    }
    /**
     * 获取品控质检表单信息
     */
    getExamineFormInfo(formData) {
        const that = this;
        if (!formData)
            return [];
        const forms = [];
        // 这里组装批量入库或出库信息
        that.dialogProduct.products.forEach((item) => {
            // 公共字段
            forms.push({
                orderNumber: `ZJ-${new Date().format('yyyyMMddhhmmss')}${Math.floor(Math.random() * 10000)}`,
                dataSource: formData.dataSource,
                salesOrderId: formData.salesOrderId,
                salesOrderType: formData.salesOrderType,
                salesOrderNumber: formData.salesOrderNumber,
                productTypeInfoId: (item.productInfo || {}).id,
                deviceCode: item.deviceCode,
                productName: item.productName,
                productShortName: item.productShortName,
                serial: item.serial,
                model: item.model,
                specifications: item.specifications,
                deviceRemark: '',
                applicant: formData.applicant,
                applicationDate: formData.applicationDate,
                quantity: item.stockInOutQuantity,
                examineResult: 0,
                remark: formData.remark,
            });
        });
        return forms;
    }
    /**
     * 设置产品值
     * @param productInfo
     * @param row
     */
    async setProduct(productInfo, row) {
        const that = this;
        row.productTypeInfoId = productInfo.id; // 产品id
        row.productInfo = productInfo; // 产品集合
        row.productLine = productInfo.productLine; // 产品线
        row.productType = productInfo.category; // 产品类别
        row.productTypeName = productInfo.category == 0 ? '独立设备' : '包装产品';
        row.deviceCode = ''; // 设备编号 实际
        row.productName = productInfo.productName; // 产品名称
        row.productShortName = productInfo.shortName; // 产品简称
        row.serial = productInfo.serial;
        row.model = productInfo.model;
        row.specifications = productInfo.specifications;
        row.stockInOutQuantity = 1; // 出/库数量默认为1，但是独立设备不运行修改
        row.quantityUnit = productInfo.unit;
        row.inboundType = '退库'; // 入库类型
    }
    /**
     * 获取销售订单产品信息
     */
    async getSalesProduct(params) {
        const that = this;
        const res = await that.axios.get('/api/erp/order/sales/return/product', {
            params: params,
        });
        return (res.data && res.data.result) || [];
    }
    /**
     * 保存订单表单
     */
    async saveOrderForm() {
        const that = this;
        if (!(that.dialogOrder.operType === 'del')) {
            // 一定要关联产品
            if ((that.dialogOrder.products || []).length === 0) {
                that.snackbar.warn('未关联产品，请先关联产品.');
                return;
            }
            if (!that.$refs['refFormPro'].validate()) {
                that.snackbar.warn('请填写必要字段后重新保存.');
                return;
            }
        }
        const form = {
            ...that.dialogOrder.formData,
            products: that.dialogOrder.products || [],
        };
        let month = '';
        let url = '/api/erp/order/sales/return';
        let msg = '';
        // 添加
        if (that.dialogOrder.operType == 'add') {
            month = 'post';
            msg = '添加';
        }
        else if (that.dialogOrder.operType == 'edit') {
            month = 'put';
            url += '/' + form.id;
            msg = '修改';
        }
        else if (that.dialogOrder.operType == 'del') {
            month = 'delete';
            url += '/' + form.id;
            msg = '删除';
        }
        else if (that.dialogOrder.operType == 'send') {
            // 开始生产
            month = 'put';
            url += '/status/' + form.id;
            msg = '修改';
            form.orderStatus = 4; // 配送中状态
        }
        else if (that.dialogOrder.operType == 'sign') {
            // 开始生产
            month = 'put';
            url += '/status/' + form.id;
            msg = '修改';
            form.orderStatus = 5; // 已签收待入库状态
        }
        await that.sendOrderSalesResponse({
            month: month,
            url: url,
            form: form,
            msg: msg,
        });
    }
    /**
     * 发送订单响应
     */
    async sendOrderSalesResponse(op) {
        const that = this;
        await that.axios[op.month](op.url, op.form)
            .then((res) => {
            that.dialogOrder.loading = false;
            // 提示成功刷新页面
            that.dialogOrder.visible = false;
            that.snackbar.success(`${op.msg}订单信息成功`);
            that.getDataList();
        })
            .catch((e) => {
            that.dialogOrder.loading = false;
            const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
            that.snackbar.error(`${op.msg}订单信息错误${resMeg}`);
            console.log(`${op.msg}订单信息错误`, e);
        });
    }
    /**
     * 显示订单状态确认表单
     */
    showStatusFormClick(orderStatus, row) {
        const that = this;
        const option = that.orderStatusArray.find((o) => o.value == orderStatus);
        if (!option)
            return;
        that.dialogStatus.title = option.label;
        that.dialogStatus.visible = true;
        that.dialogStatus.formOption = Object.assign({}, option);
        that.dialogStatus.formData = Object.assign({}, row);
        that.dialogStatus.formData.confirmDate = new Date().format('yyyy-MM-dd');
    }
    async saveOrderStatusForm() {
        const that = this;
        if (!that.$refs['refStatusForm'].validate()) {
            that.snackbar.warn('请填写必要字段后重新保存.');
            return;
        }
        // 覆盖表单原有数据
        const form = that.dialogStatus.formData;
        form[that.dialogStatus.formOption.fieldName] = form.confirmName;
        form[that.dialogStatus.formOption.fieldDate] = form.confirmDate;
        await that.axios
            .put('/api/erp/order/sales/return/audit/' + form.id, form)
            .then((res) => {
            that.dialogStatus.loading = false;
            // 提示成功刷新页面
            that.dialogStatus.visible = false;
            that.snackbar.success('确认订单信息成功');
            that.getDataList();
        })
            .catch((e) => {
            that.dialogStatus.loading = false;
            const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
            that.snackbar.error(`确认订单信息错误${resMeg}`);
            console.log('确认订单信息错误', e);
        });
    }
    /**
     * 添加产品容器
     */
    addProductContainer() {
        const that = this;
        if (that.dialogOrder.products.length > 0) {
            // 判断是否有为空的产品容器
            if (that.dialogOrder.products.findIndex((o) => (o.productInfoId || '').length == 0) > -1) {
                that.snackbar.warn('请先填写完毕后增加产品.');
                return;
            }
        }
        that.dialogOrder.products.push({
            outboundOrderId: '',
            productInfo: '',
            productInfoId: '',
            productName: '',
            model: '',
            specifications: '',
            quantity: '0',
            quantityUnit: '',
            remark: '',
        });
        // 在添加控件后滚动到底部
        that.$nextTick(() => {
            that.$refs.refFormPro.$el.scrollTop = that.$refs.refFormPro.$el.scrollHeight;
        });
    }
    /**
     * 删除产品容器
     */
    delProductContainer(index) {
        const that = this;
        that.dialogOrder.products.splice(index, 1);
    }
    /**
     * 生成订单编号
     */
    async generateOrderNo() {
        const that = this;
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const prefix = that.dialogOrder.formData.orderType === '销售' ? 'XS' : that.dialogOrder.formData.orderType === '试用' ? 'CS' : 'YF';
        const randomNumber = Math.floor(Math.random() * 100000)
            .toString()
            .padStart(5, '0');
        const orderNumber = `${prefix}-${year}${month}${day}${randomNumber}`;
        that.$nextTick(() => {
            // 清空这一行
            that.$set(that.dialogOrder.formData, 'orderNumber', orderNumber);
        });
    }
    getOrderStatusOption(orderStatus) {
        const that = this;
        const option = that.orderStatusArray.find((o) => o.value == orderStatus);
        return option || {};
    }
    // 产品列表
    async getProductList() {
        const that = this;
        const res = await that.axios.get('/api/erp/inventory/statistics');
        that.productList = (res.data && res.data.result) || [];
    }
    async getDataList() {
        const that = this;
        that.orderTableOption.loading = true;
        try {
            const res = await that.axios.get('/api/erp/order/sales/return', {
                params: {
                    withProducts: true,
                    page: that.orderTableOption.pagination.pageNow,
                    limit: typeof that.orderTableOption.pagination.everyPageCount === 'number'
                        ? that.orderTableOption.pagination.everyPageCount
                        : that.orderTableOption.pagination.sumDetail,
                    keyword: that.searchForm.keyword,
                    hospitalId: that.searchForm.hospitalId,
                    startDate: (that.searchForm.dates.length > 0 && that.searchForm.dates[0]) || '',
                    endDate: (that.searchForm.dates.length > 1 && that.searchForm.dates[1]) || '',
                    orderType: !/全部|所有/.test(that.searchForm.orderType) ? that.searchForm.orderType : '',
                    orderStatus: (that.searchForm.orderStatus && that.searchForm.orderStatus.toString()) || '',
                },
            });
            that.orderTableOption.desserts = res.data.result || [];
            // 处理签订日期数据
            that.orderTableOption.desserts.forEach((item) => {
                for (let index = 0; index < that.operDateArray.length; index++) {
                    const key = that.operDateArray[index];
                    if (item[key])
                        item[key] = new Date(item[key]).format('yyyy-MM-dd');
                }
            });
            that.orderTableOption.pagination.sumDetail = res.data.sum || 0;
            // 分页信息处理
            that.orderTableOption.pagination.sumDetail = res.data.sum;
            const pageCount = Math.ceil(res.data.sum / that.orderTableOption.pagination.everyPageCount) || 1;
            that.orderTableOption.pagination.pageCount = pageCount;
            if (that.orderTableOption.pagination.pageNow > pageCount) {
                that.orderTableOption.pagination.pageNow = pageCount;
                that.getDataList();
            }
        }
        catch (e) {
            console.log(e);
        }
        finally {
            that.orderTableOption.loading = false;
        }
    }
    searchChange() {
        const that = this;
        clearTimeout(that.searchForm.timer);
        that.searchForm.timer = setTimeout(() => {
            that.getDataList();
        }, 300); // 1秒执行一次获取函数 防抖
    }
    /**
     * 跳转参数处理
     */
    skipParams() {
        const that = this;
        const orderStatusParams = (this.$route.params || {}).orderStatus || '';
        if (orderStatusParams) {
            that.searchForm.orderStatus = orderStatusParams.split(',').map(Number);
        }
    }
    async initUserList() {
        const that = this;
        if ((that.userInfoDic.list || []).length > 0) {
            // 已查询过就不在添加
            return;
        }
        that.userInfoDic.loading = true;
        const res = await that.axios.get('/api/users/');
        that.userInfoDic.list = [];
        if (res.data && res.data.result) {
            res.data.result.filter((o) => {
                if (o.usersInfo)
                    that.userInfoDic.list.push(o.usersInfo);
            });
        }
        that.userInfoDic.loading = false;
    }
    async mounted() {
        const that = this;
        that.skipParams();
        await that.getDataList();
        that.initUserList();
    }
};
__decorate([
    Getter
], SalesOrder.prototype, "userInfo", void 0);
SalesOrder = __decorate([
    Component({
        name: 'SalesOrder',
        components: {
            BcSnackbar,
            BcDialog,
            BcTable,
        },
    })
], SalesOrder);
export default SalesOrder;
